import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import Typography from '../../../components/overrides/Typography';
import {
  SEARCH_CURATED_PICKS_INFO_BOX_EVENT_DESCRIPTION,
  SEARCH_CURATED_PICKS_INFO_BOX_EVENT_TITLE,
  SEARCH_CURATED_PICKS_INFO_BOX_SIGNATURE_COLLECTION_DESCRIPTION,
  SEARCH_CURATED_PICKS_INFO_BOX_SIGNATURE_COLLECTION_TITLE,
} from '../../../assets/copy';
import { CURATED_PICKS_TYPE } from '../../../utils/constants/CuratedPickTypes';

const getTitleAndDescription = (type) => {
  switch (type) {
    case CURATED_PICKS_TYPE.SIGNATURE_COLLECTION:
      return {
        title: SEARCH_CURATED_PICKS_INFO_BOX_SIGNATURE_COLLECTION_TITLE,
        description:
          SEARCH_CURATED_PICKS_INFO_BOX_SIGNATURE_COLLECTION_DESCRIPTION,
      };
    case CURATED_PICKS_TYPE.EVENTS:
      return {
        title: SEARCH_CURATED_PICKS_INFO_BOX_EVENT_TITLE,
        description: SEARCH_CURATED_PICKS_INFO_BOX_EVENT_DESCRIPTION,
      };
    default:
      throw new Error('Invalid curated pick type');
  }
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    background: theme.palette.beacon.atlantic,
    borderRadius: '4px',
    padding: theme.spacing(1, 1.25),
    [theme.breakpoints.up('xxl')]: {
      padding: theme.spacing(2, 2.25),
    },
  },
  title: {
    color: theme.palette.text.secondary,
    paddingBottom: theme.spacing(0.5),
  },
  description: {
    color: theme.palette.text.secondary,
  },
}));

const CuratedPickInfoBox = ({ type }) => {
  const classes = useStyles();

  try {
    const { title, description } = getTitleAndDescription(type);

    return (
      <Box className={classes.container}>
        <Typography variant="small2Semibold" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="small3Normal" className={classes.description}>
          {description}
        </Typography>
      </Box>
    );
  } catch (error) {
    return null;
  }
};

export default CuratedPickInfoBox;
